import IGridComponent from '../../../components/grid/i-grid.component';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { AppContext } from '../../../app-context';
import { useEffect, useState, useContext } from 'react';
import { getPriceHistory } from '../amazon.services';
import { formatDateLong, isEmptyArray } from '../../common/util.services';
import { PAGE_SIZE } from '../../common/constants';

const PriceHistoryComponent = (props: any) => {

  const columns: GridColDef[] = [
    { field: 'price', headerName: 'Price', width: 80 },
    { field: 'date', headerName: 'Date', filterable: false, sortable: false, editable: false,
      valueFormatter: (date: any) => formatDateLong(date), width: 250
    },
  ];
  
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [history, setHistory] = useState(rows);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getPriceHistory(props.sku, page, pageSize, appContext,
        (response: any) => {
          setHistory(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setSuccessMessage(response.message);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
        });
      }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  return <div>
    <IGridComponent title='' showAddBtn={false} rows={history} columns={columns} maxHeight={400}
      paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
      getRowId={(row: any) => row.rowId}/>
  </div>
}

export default PriceHistoryComponent;